import AutoPositionCell from "@folo/auto-position/src";

export default (function init() {
  const positionStore = new AutoPositionCell();

  return positionStore;
})();
